module.exports = __webpack_public_path__ + "img/effective-protection-sector-azul.8ce7bd30.svg";